module.exports = __webpack_public_path__ + "img/btn-green-bm.a453ee72.png";